export const errorInterceptor = (error) => {
  console.error(error);
  
  if (!error.response) {
    console.error("Network error");
  }

  if (error.response?.status === 403) {
    console.error("Forbidden");
  }

  return Promise.reject(error);
};
